Object.defineProperty(exports,"__esModule",{value:true});exports.RootModalId=void 0;var RootModalId=exports.RootModalId='root-modal-alert';